// utils/validation.js
export const validateCode = (code) => {
  const errors = {};
  
  if (!code?.code?.trim()) errors.code = 'Code is required';
  if (!code?.description?.trim()) errors.description = 'Description is required';
  if (!code?.rating || isNaN(code.rating) || code.rating <= 0) {
    errors.rating = 'Rating must be a positive number';
  }
  
  return errors;
};

export const validateNewCode = (newCodeForm) => {
  const errors = {};
  
  if (!newCodeForm.code?.trim()) errors.code = 'Code is required';
  if (!newCodeForm.description?.trim()) errors.description = 'Description is required';
  if (!newCodeForm.rating || isNaN(newCodeForm.rating) || parseInt(newCodeForm.rating) <= 0) {
    errors.rating = 'Rating must be a positive number';
  }
  
  return errors;
};